"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrescribeModule = void 0;
const prescribe_view_1 = require("./modules/prescribe-view");
const router_1 = require("client/components/router");
class PrescribeModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("prescribe", /^\/prescribe?$/, prescribe_view_1.PrescribeView);
    }
}
exports.PrescribeModule = PrescribeModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/prescribe/prescribe.tsx
// module id = 3830
// module chunks = 0